export default {
  laudar: 'LAUDAR',
  andamento: 'ANDAMENTO',
  publicado: 'PUBLICADO',
  erro: 'ERRO'
}



// WEBPACK FOOTER //
// ./src/utils/reportStatusType.js